import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useDeleteLevel, useLevelsQuery } from "../api/queries";
import { LevelsFilter } from "../ui/levels/LevelsFilter";
import { LevelsTable } from "../ui/levels/LevelsTable";
import { LevelsToolbar } from "../ui/levels/LevelsToolbar";

export function LevelsPage() {
  const nav = useNavigate({ from: "/app/master/levels" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/master/levels",
  });

  const list = useLevelsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["master:create"]);
  const deleteLevel = useDeleteLevel();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ລະດັບ" },
          ]}
        />
      </Header>

      <Main>
        <LevelsToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/master/levels/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <LevelsFilter />

          <LevelsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(level) =>
              nav({
                to: "/app/master/levels/$id/edit",
                params: { id: level.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteLevel.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບລະດັບສຳເລັດ",
                error: "ລຶບລະດັບລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
